import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToHash = (offset = 120) => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      // 1. Prevent the browser from jumping to the top automatically
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }

      const targetId = hash.replace("#", "");
      
      const scrollToElement = () => {
        const element = document.getElementById(targetId);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      };

      // 2. Execute scroll with a slight delay to ensure content is painted
      const timer = setTimeout(scrollToElement, 100);

      return () => {
        clearTimeout(timer);
        // Reset restoration to auto when leaving the page if desired
        if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'auto';
        }
      };
    } else {
      // 3. If there is NO hash, scroll to top (Standard page transition)
      window.scrollTo(0, 0);
    }
  }, [hash, pathname, offset]); // Added pathname to detect page changes
};

export default useScrollToHash;